import { CommonModule } from '@angular/common';
import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ApplicationStore } from '@core/stores/application.store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { form, FormField, required } from '@angular/forms/signals';
import { signalMethod } from '@ngrx/signals';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-locale-switcher',
  templateUrl: './locale-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    MatSelectModule,
    FormField
  ]
})
export class LocaleSwitcherComponent {
  readonly applicationStore = inject(ApplicationStore);
  readonly translateService = inject(TranslateService);

  languageModel = signal<{ language: string }>({
    language: this.applicationStore.currentLanguage()
  });

  languageForm = form(this.languageModel, (schemaPath) => {
    required(schemaPath.language);
  });

  readonly changeLanguage = signalMethod<{ language: string }>(({ language }) => {
    this.translateService.use(language);
  });

  constructor() {
    this.changeLanguage(this.languageModel);
  }
}

